module.exports = __webpack_public_path__ + "img/dump-truck.4bbafc2e.svg";